import script from "./ServiceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceCard.vue?vue&type=script&setup=true&lang=js"

import "./ServiceCard.vue?vue&type=style&index=0&id=9a19afa6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a19afa6"]])

export default __exports__